<h2>Пожалуйста, подождите</h2>
<h3>{{ h3 }}</h3>
<div class="progress-bar-container">
  <mat-progress-bar
    mode="indeterminate"
    color="rgba(0, 150, 50, 1)"
    style=""
  >
  </mat-progress-bar>
</div>
